import PusherClient from "pusher-js";

// Determine if we're in local environment
const isLocalEnv = process.env.NEXT_PUBLIC_ENVIRONMENT === "local";

export const pusherClient = new PusherClient(
  process.env.NEXT_PUBLIC_PUSHER_KEY!,
  {
    cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER!,
    // Enable non-secure connections for local development
    forceTLS: !isLocalEnv,
    enabledTransports: isLocalEnv ? ["ws", "wss"] : ["wss"],
  }
);
